import dynamic from "next/dynamic"
import { memo } from "react"

function WinsAndReviewCard({ component, ...item }) {
  let Card = () => null

  switch (component) {
    case "case_win":
      Card = dynamic(() => import("./CaseWin"))
      break
    case "video_review":
      Card = dynamic(() => import("./VideoReview"))
      break
    case "client_review":
      Card = dynamic(() => import("./ClientReview"))
      break
    case "attorney_endorsement":
      Card = dynamic(() => import("./AttorneyEndorsement"))
      break
    default:
      console.error("An invalid value was passed into the WinsAndReviewCard component prop.")
      break
  }
  return <Card {...item} />
}

export default memo(WinsAndReviewCard)